import { Button, Checkbox, Dialog, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import MFSelectField from '../../lib/formik/SelectField';
import { Notes, ProceedSaveLater, SubHeading } from '../investors/components';
import { MFTextField } from '../../lib/formik';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import {
  AmlSystemMatch,
  Applicant,
  ApplicationProps,
  Broker,
  BrokerList,
  DPNameType,
  Groups,
  coparcenersType,
} from '../../redux-store/types/api-types';
import {
  CKYC_SELECTION_OPTIONS_OBJECT,
  DLCLMasters,
  investorTypeMasters,
  NON_REPEATED_RELATIONS,
  PEPsMasters,
  Relations,
  SOURCE_OF_FUNDS_MASTER,
  USER_ROLES,
  YES_NO_BOOLEAN_MASTER,
  YES_NO_MASTER,
  AOI_BOI_MASTER,
  KBOLT_XALT_MASTER,
} from '../../utils/constant';
import { DatePicker } from '../../lib/formik/DatePicker';
import React, { useEffect, useState } from 'react';
import {
  applicationComparison,
  checkIfApplicationIsNonIndividualPOA,
  checkInvestorTypeChanged,
  checkKartaUpdated,
  clearclIdField,
  cleardpIdField,
  currencyConversion,
  getAuthorisedSignatoryBasedOnKarta,
  isAmcCallVerified,
  isCkycMandatory,
  isHufType,
  isOtherSourceOfFund,
  isValidPEP,
  preventSpecialCharacters,
  dlclIdFieldMandatory,
  removeSingleQuote,
  saveForLater,
  statusRoleBased,
  getGrossAnnualMasters,
  getInvestorTypeMasters,
  isOtherTypeOfInvestor,
  ifPushToXalt,
  getOlderDate,
} from '../../utils/utilityFunctions';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import { getBrokers, updateApplication } from '../../redux-store/actions/application';
import {
  NonIndividualContributorValidationSchema,
  nonIndividualCoparceres,
} from '../../utils/schema';
import { useSnackbar } from 'notistack';
import UseRadioGroup from '../../lib/formik/Radio';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { ConfirmationDialog, CountryCodesDropDown } from '../commonComponents';
import { Box } from '@mui/system';
import { DataTable } from '../DataTable';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { formatShortDate, formatShortDateAndTime } from '../../utils/date';
import { showError } from '../../redux-store/actions/auth';
import { DematDetails, ckycDeclaration } from '../investors/additionalKYCDetails';
import { nonDigitRegex } from '../../utils/regex';
import { useFeatureToggles, useMdmsBrokerListData } from '../../utils/useDataMdms';
import { getDPNameList } from '../../redux-store/actions/userManagement';

type UpdatedApplicant = Partial<Applicant & { otherSourceOfFunds: string }>;

export const coparcenersListingObject: coparcenersType = {
  relation: '',
  karta: false,
  name: '',
  pan: '',
  mobile: '',
  dob: '',
  relationShipOthers: '',
  countryNameAndCode: 'India: +91',
  countryCode: '+91',
  email: '',
  designation: '',
  isActive: true,
};

const contributorObject: UpdatedApplicant = {
  name: '',
  cityOfIncorporation: '',
  ckycNo: '',
  ckyc_selection_options: '',
  investorType: '',
  otherInvestorType: '',
  dateOfBirth: '',
  panNo: '',
  grossAnnualIncome: '',
  netWorth: '',
  politicallyExposedPersonStatus: '',
  dlclId: dlclIdFieldMandatory() ? '' : 'none',
  nameOfBroker: '',
  dematName: '',
  amcCallVerified: '',
  sourceOfFunds: '',
  otherSourceOfFunds: '',
  dataFetchedFromKRA: null,
  kraMobileNumber: '',
  kraEmailId: '',
  boiOrAop: '',
  broker_id: null,
};

export type Values = {
  saveType: string;
  modeOfHolding: string;
  applicants: UpdatedApplicant[];
  coparceners: coparcenersType[];
};

const initialValues: Values = {
  modeOfHolding: 'single',
  applicants: [contributorObject],
  saveType: 'save and proceed',
  coparceners: [],
};

export default function ContributorDetails(): JSX.Element {
  const { application } = useSelector((store: RootStateType) => store.application);
  const [contributorValues, setContributorValues] = useState(initialValues);
  const history = useHistory();
  const dispatch = useDispatch();
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [brokerList, setBrokerList] = useState<BrokerList>();
  const { BrokerList } = useMdmsBrokerListData();
  const { toggler } = useFeatureToggles();
  const [dpbrokerList, dpsetBrokerList] = useState<DPNameType[]>([]);

  useEffect(() => {
    (async function () {
      try {
        setBrokerList(BrokerList as BrokerList);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
  }, [BrokerList]);

  useEffect(() => {
    const fetchBrokerList = async () => {
      try {
        const response = (await dispatch(getDPNameList())) as unknown as DPNameType[];
        dpsetBrokerList(response);
      } catch (e) {
        console.error((e as Error).message);
      }
    };
    fetchBrokerList();
  }, []);

  useEffect(() => {
    try {
      const { applicants = [], coparceners = [] } = application || {};
      setContributorValues({
        ...contributorValues,
        applicants: applicants.length
          ? applicants.map((applicant) => {
              return {
                ...applicant,
                // eslint-disable-next-line
                amlCheck: (applicant.amlCheck ? 'Yes' : 'No') as any,
                dlclId: applicant.dlclId ? applicant.dlclId : dlclIdFieldMandatory() ? '' : 'none',
                nameOfBroker: applicant.nameOfBroker || '',
                broker_id: applicant.broker_id || null,
                dematName: applicant.dematName || '',
                amcCallVerified: applicant.amcCallVerified || '',
                sourceOfFunds:
                  applicant.sourceOfFunds && isOtherSourceOfFund(applicant.sourceOfFunds || '')
                    ? 'others'
                    : applicant.sourceOfFunds || '',
                otherSourceOfFunds: isOtherSourceOfFund(applicant.sourceOfFunds || '')
                  ? applicant.sourceOfFunds
                  : '',
                dataFetchedFromKRA: applicant.dataFetchedFromKRA || false,
                otherInvestorType: applicant?.otherInvestorType || '',
                boiOrAop: applicant.boiOrAop || '',
              };
            })
          : [contributorObject],
        coparceners: coparceners.length ? coparceners : [],
      });
    } catch (e) {
      console.error((e as Error).message);
    }
  }, [application]);

  const handleApplicant = async (values: Values) => {
    const { saveType, applicants = [], coparceners } = values;
    const {
      id,
      currentStep,
      banks = [],
      createdAt = '',
      applicant1ReferenceId = '',
      applicationNumber,
      topupApplicationNumber,
    } = application || {};
    // const isAllBanksPennyChecked = banks.length
    //   ? banks.every((bank) => bank.pennydropCheck)
    //   : false;
    // const contributorDetailsFieldsCheck = application?.applicants
    //   .map((applicant, index) => {
    //     return applicants.map((_applicant, ind) => {
    //       if (index === ind) {
    //         const { investorType } = _applicant;
    //         if (investorType !== applicant.investorType) {
    //           return 'true';
    //         }
    //         return 'false';
    //       }
    //       return 'false';
    //     });
    //   })
    //   .flat();

    const alreadySelectedRelations = coparceners
      ?.filter((item) => item.isActive)
      .map((coparcener) => coparcener.relation);
    const repeatedRelations = alreadySelectedRelations.filter(
      (relation, index) => alreadySelectedRelations.indexOf(relation) !== index
    );
    const activeCoparcenersCount = coparceners?.filter((item) => item.isActive).length;
    const karta = coparceners?.filter((item) => item.isActive && item.karta);
    const kartaCount = karta.length;
    const getDeactivatedAuthorisedSignatories = application?.groups.map((group) => {
      return { ...group, isActive: false };
    }) as Groups[];
    if (
      isHufType(applicants || []) &&
      !checkIfApplicationIsNonIndividualPOA(application as ApplicationProps)
    ) {
      if (!activeCoparcenersCount) {
        throw 'Please Add Coparceners';
      }
      if (kartaCount > 1) {
        throw 'There can be only one Karta';
      }

      if (kartaCount === 0) {
        throw 'Please select Karta';
      }
      karta.forEach((coparcener) => {
        if (!coparcener.mobile) {
          throw 'Karta Mobile Number is mandatory';
        }
        if (!coparcener.email) {
          throw 'Karta email is mandatory';
        }
      });
      repeatedRelations.forEach((relation) => {
        if (NON_REPEATED_RELATIONS.includes(relation)) {
          throw `There can be only one coparcener with the relation - ${relation}`;
        }
      });
    }
    const checkApplication = applicationComparison(
      {
        ...application,
        applicants: application?.applicants
          .map((applicant) => ({
            ...applicant,
            name: removeSingleQuote(applicant.name),
            cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
          }))
          ?.sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
      },
      {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        banks:
          values.applicants[0].name?.split("'").join('').trim() ===
          application?.applicants[0].name?.split("'").join('').trim()
            ? banks
            : banks.map((bank) => ({
                ...bank,
                pennydropCheck: false,
                pennydropVerified: false,
              })),
        applicants: values.applicants
          .map((applicant) => {
            const { otherSourceOfFunds, ...restApplicant } = applicant;
            return {
              ...restApplicant,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
              sourceOfFunds: isOtherSourceOfFund(applicant.sourceOfFunds || '')
                ? applicant.otherSourceOfFunds
                : applicant.sourceOfFunds,
              clId: clearclIdField(applicant.dlclId || '', createdAt) ? '' : applicant.clId,
              dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant.dpId?.toUpperCase(),
              otherInvestorType: isOtherTypeOfInvestor(applicant?.investorType || '')
                ? applicant.otherInvestorType
                : null,
            };
          })
          .sort((applicant1, applicant2) => Number(applicant1.id) - Number(applicant2.id)),
        modeOfHolding: 'single',
        coparceners:
          isHufType(applicants || []) &&
          !checkIfApplicationIsNonIndividualPOA(application as ApplicationProps)
            ? coparceners.map((coparceners) => {
                return {
                  ...coparceners,
                  name: removeSingleQuote(coparceners.name),
                  designation: removeSingleQuote(coparceners.designation),
                  email: removeSingleQuote(coparceners.email),
                };
              })
            : coparceners.map((coparcener) => {
                return { ...coparcener, isActive: false };
              }),
        groups:
          isHufType(applicants || []) &&
          !checkIfApplicationIsNonIndividualPOA(application as ApplicationProps)
            ? application?.groups.length
              ? !checkKartaUpdated(values.coparceners, application.coparceners)
                ? [
                    ...getAuthorisedSignatoryBasedOnKarta(values.coparceners || []),
                    ...getDeactivatedAuthorisedSignatories,
                  ]
                : application.groups
              : getAuthorisedSignatoryBasedOnKarta(values.coparceners || [])
            : application?.groups,

        currentStep: !!currentStep && currentStep > 1 ? currentStep : Number(currentStep) + 1,
      }
    );

    if (id && !checkApplication) {
      await dispatch(
        updateApplication({
          body: {
            ...application,
            banks:
              values.applicants[0].name?.split("'").join('').trim() ===
              application?.applicants[0].name?.split("'").join('').trim()
                ? banks
                : banks.map((bank) => ({
                    ...bank,
                    pennydropCheck: false,
                    pennydropVerified: false,
                  })),
            applicants: values.applicants.map((applicant) => ({
              ...applicant,
              name: removeSingleQuote(applicant.name),
              cityOfIncorporation: removeSingleQuote(applicant.cityOfIncorporation),
              clId: clearclIdField(applicant.dlclId || '', createdAt) ? '' : applicant.clId,
              dpId: cleardpIdField(applicant.dlclId || '') ? '' : applicant.dpId?.toUpperCase(),
              nameOfBroker: cleardpIdField(applicant.dlclId || '') ? '' : applicant.nameOfBroker,
              broker_id: cleardpIdField(applicant.dlclId || '') ? null : applicant.broker_id,
              dematName: cleardpIdField(applicant.dlclId || '') ? '' : applicant.dematName,
              sourceOfFunds: isOtherSourceOfFund(applicant.sourceOfFunds || '')
                ? applicant.otherSourceOfFunds
                : applicant.sourceOfFunds,
              otherInvestorType: isOtherTypeOfInvestor(applicant?.investorType || '')
                ? applicant.otherInvestorType
                : null,
              boiOrAop:
                ifPushToXalt(application?.pushDataTo || '') &&
                investorTypeMasters[applicant?.investorType || ''] ===
                  investorTypeMasters.boi_or_aop
                  ? applicant.boiOrAop
                  : '',
            })),
            coparceners:
              isHufType(applicants || []) &&
              !checkIfApplicationIsNonIndividualPOA(application as ApplicationProps)
                ? coparceners.map((coparceners) => {
                    return {
                      ...coparceners,
                      name: removeSingleQuote(coparceners.name),
                      designation: removeSingleQuote(coparceners.designation),
                      email: removeSingleQuote(coparceners.email),
                    };
                  })
                : coparceners.map((coparcener) => {
                    return { ...coparcener, isActive: false };
                  }),
            modeOfHolding: 'single',
            status: statusRoleBased(role, application),
            groups:
              isHufType(applicants || []) &&
              !checkIfApplicationIsNonIndividualPOA(application as ApplicationProps)
                ? application?.groups.length
                  ? !checkKartaUpdated(values.coparceners, application.coparceners)
                    ? [
                        ...getAuthorisedSignatoryBasedOnKarta(values.coparceners || []),
                        ...getDeactivatedAuthorisedSignatories,
                      ]
                    : application.groups
                  : getAuthorisedSignatoryBasedOnKarta(values.coparceners || [])
                : checkInvestorTypeChanged(application, values)
                ? getDeactivatedAuthorisedSignatories
                : application?.groups,
            currentStep: 2,
            // !!currentStep && currentStep > 1
            //   ? (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //     ? 2
            //     : currentStep
            //   : (values.applicants[0].name?.trim() !== application?.applicants[0].name?.trim() &&
            //       isAllBanksPennyChecked) ||
            //     (contributorDetailsFieldsCheck as unknown as string[])?.includes('true')
            //   ? 2
            //   : Number(currentStep) + 1,
          },
          applicationId: id,
          ...(saveType !== 'save and proceed' && {
            toastMessage: '',
          }),
        })
      );
      saveType === 'save and proceed'
        ? history.push('contact-details', {
            id,
            applicant1ReferenceId,
            topUpApplication: application?.isTopup,
          })
        : history.push(saveForLater(role, id, applicant1ReferenceId, application?.isTopup), {
            topUpApplication: application?.isTopup,
          });
    } else if (checkApplication) {
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(
          `Application ${application?.isTopup ? topupApplicationNumber : applicationNumber} - ` +
            ' Saved successfully',
          {
            variant: 'success',
            autoHideDuration: 3000,
          }
        );
      }
      saveType === 'save and proceed'
        ? history.push('contact-details', {
            id,
            applicant1ReferenceId,
            topUpApplication: application?.isTopup,
          })
        : history.push(saveForLater(role, id, applicant1ReferenceId, application?.isTopup), {
            topUpApplication: application?.isTopup,
          });
    }
  };

  const handleSubmit = async (values: Values) => {
    try {
      setLoading(true);
      const { id, applicant1ReferenceId = '', applicationNumber } = application || {};
      const { saveType } = values;
      await handleApplicant(values);
      saveType === 'save and proceed'
        ? history.push('contact-details', { id, applicant1ReferenceId })
        : history.push(saveForLater(role, id, applicant1ReferenceId));
      if (saveType !== 'save and proceed') {
        enqueueSnackbar(`Application ${applicationNumber} - ` + ' Saved successfully', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
      //history.push(`document-details`, { applicationType: 'non_individual' });
    } catch (e) {
      setLoading(false);
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  const headers = [
    {
      header: 'Name',
      label: 'name',
      valueGetter: (row: coparcenersType) => row.name || 'N/A',
    },
    {
      header: 'Relation',
      valueGetter: (row: coparcenersType) =>
        row.relation === 'Others' ? row.relationShipOthers : row.relation || 'N/A',
    },
    {
      header: 'Date of Birth',
      valueGetter: (row: coparcenersType) =>
        (row.dob ? formatShortDate(new Date(row.dob)) : 'N/A') || 'N/A',
    },
  ];

  function CoparceresDetails({ coparcenersValues }: { coparcenersValues: Values }): JSX.Element {
    const [open, setOpen] = useState(false);
    const [coparcenersListing, setCoparceresListing] = useState(coparcenersListingObject);
    const [rowIndex, setRowIndex] = useState(Number);
    const [deletePopup, setDeletePopup] = useState(false);
    const handleClose = () => {
      setCoparceresListing(coparcenersListingObject);
      setRowIndex(Number);
      setOpen(false);
    };

    const onSubmit = (values: coparcenersType) => {
      const editcoparceners = coparcenersValues.coparceners
        .filter((_item) => _item.isActive)
        .map((_coparceners, ind) => {
          if (ind === rowIndex) {
            return {
              ...values,
            };
          }
          return { ..._coparceners, isFetchData: false };
        });
      const deletedcoparcenerss = coparcenersValues.coparceners.filter(
        (_item) => !_item.isActive && _item.id
      );
      setContributorValues({
        ...coparcenersValues,
        coparceners:
          coparcenersListing.name === ''
            ? [
                ...coparcenersValues.coparceners,
                {
                  ...values,
                },
              ]
            : [...editcoparceners, ...deletedcoparcenerss],
      });
      handleClose();
    };

    const sendToEsignCell = {
      header: (): JSX.Element => {
        const [open, setOpen] = useState(false);

        const handleOpen = () => {
          setOpen(true);
        };
        const handleClose = () => {
          setOpen(false);
        };
        return (
          <>
            <Typography
              variant="h6"
              sx={{
                fontFamily: 'Poppins, sans-serif',
                fontSize: 14,
                fontWeight: 500,
                color: 'primary.main',
                pr: 0.5,
              }}
              component="span">
              Karta
            </Typography>
            <InfoOutlinedIcon
              color="info"
              fontSize="small"
              onClick={handleOpen}
              sx={{ position: 'relative', top: 4 }}
            />
            <Dialog
              onClose={handleClose}
              open={open}
              sx={{
                '.MuiPaper-root ': {
                  maxWidth: 400,
                  p: { xs: 2, sm: '15px 20px 45px' },
                  borderRadius: '10px',
                  height: 'unset',
                  overflowY: 'auto',
                },
              }}>
              <IconButton onClick={handleClose} sx={{ alignSelf: 'flex-end' }}>
                <CloseIcon fontSize="medium" />
              </IconButton>
              <Box
                sx={{ mb: 2, textAlign: 'center', '.MuiSvgIcon-root': { fontSize: '3.1875rem' } }}>
                <InfoOutlinedIcon color="info" fontSize="large" />
              </Box>
              <Box
                sx={{
                  width: { xs: '100%', sm: '80%' },
                  mx: 'auto',
                  '.MuiTypography-root': {
                    fontSize: 20,
                    fontWeight: 500,
                    textAlign: 'center',
                  },
                }}>
                <Typography sx={{ color: 'secondary.main', lineHeight: '35px' }}>
                  Use this option to set Karta.
                </Typography>
              </Box>
            </Dialog>
          </>
        );
      },
      renderEditDeleteCell: (row: coparcenersType, index: number): JSX.Element => {
        return (
          <Checkbox
            checked={row.karta}
            sx={{ display: { xs: 'block' }, ':hover': { backgroundColor: 'white' } }}
            onChange={() => {
              const activeCoparceners = contributorValues.coparceners
                .filter((_item) => _item.isActive)
                .map((_coparceners, _ind) => {
                  if (index === _ind) {
                    return { ..._coparceners, karta: !_coparceners.karta };
                  }
                  return _coparceners;
                });
              const deletedcoparceners = contributorValues.coparceners.filter(
                (_item) => !_item.isActive && _item.id
              );
              setContributorValues({
                ...contributorValues,
                coparceners: [...activeCoparceners, ...deletedcoparceners],
              });
              setCoparceresListing(coparcenersListingObject);
              setRowIndex(Number);
            }}
          />
        );
      },
    };

    const editCell = {
      header: '',
      renderEditDeleteCell: (row: coparcenersType, index: number): JSX.Element => {
        return (
          <Box display="flex">
            <Tooltip title="Edit">
              <IconButton
                onClick={() => {
                  setCoparceresListing({
                    ...row,
                  }),
                    setRowIndex(index),
                    setOpen(true);
                }}
                sx={{
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                }}>
                <EditIcon sx={{ color: 'primary.main' }} fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                sx={{
                  ':hover': {
                    bgcolor: '#F4FCFC',
                  },
                }}
                onClick={() => {
                  setCoparceresListing(row), setRowIndex(index), setDeletePopup(true);
                }}>
                <DeleteOutlineIcon color="error" fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
    };

    return (
      <>
        {coparcenersValues.coparceners.filter((_item) => _item.isActive).length !== 0 && (
          <Grid xs={12} sm={12} lg={12} mt={3}>
            <DataTable
              tableData={coparcenersValues.coparceners.filter((_item) => _item.isActive)}
              tableHeader={[sendToEsignCell, ...headers, editCell]}
              renderAdditionalRow={false}
              tableHeaderCustomStyles={{
                '.MuiTableCell-head': {
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: 14,
                  fontWeight: 500,
                  color: 'primary.main',
                },
              }}
              rowCustomStyles={{
                '.MuiTableCell-root': {
                  py: '8px',
                  overflowWrap: 'anywhere',
                },
              }}
              boxStyles={{ minHeight: '0px', minWidth: 450 }}
            />
          </Grid>
        )}
        <Grid
          xs={12}
          sm={12}
          lg={12}
          display="flex"
          sx={{
            justifyContent: {
              xs:
                coparcenersValues.coparceners.filter((_item) => _item.isActive).length === 0
                  ? 'start'
                  : 'center',
              sm:
                coparcenersValues.coparceners.filter((_item) => _item.isActive).length === 0
                  ? 'start'
                  : 'end',
            },
          }}>
          {coparcenersValues.coparceners.filter((item) => item.isActive).length < 5 && (
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              sx={{
                color: 'primary.main',
                fontWeight: 500,
                fontSize: 13,
                mr: 2.5,
                whiteSpace: 'nowrap',
                mt: '20px',
              }}
              onClick={() => {
                setCoparceresListing(coparcenersListingObject), setOpen(true);
              }}>
              Add Coparcener
            </Button>
          )}
          <Dialog
            onClose={handleClose}
            open={open}
            sx={{
              '.MuiPaper-root ': {
                px: 1,
                width: { xs: '70%', sm: '70%' },
              },
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'space-between',
                position: 'sticky',
                top: 0,
                boxShadow: '0 2px #ccc 0.6',
                zIndex: 10,
                bgcolor: 'white',
                py: 3,
              }}>
              <Typography
                sx={{
                  color: '#0D2762',
                  fontSize: '20px',
                  fontWeight: 500,
                  ml: { xs: 2, sm: 5 },
                }}>
                {coparcenersListing.name ? 'Edit Coparcener Details' : 'Add Coparcener Details'}
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box
              sx={{
                width: { xs: '100%', sm: '90%' },
                mx: 'auto',
                px: { xs: 3, sm: 0 },
                pb: 4,
              }}>
              <Formik
                initialValues={coparcenersListing}
                onSubmit={onSubmit}
                validate={(values: coparcenersType) => {
                  try {
                    validateYupSchema(
                      values,
                      nonIndividualCoparceres,
                      true,
                      contributorValues.coparceners
                        .filter((_item) => _item.isActive)
                        .map((_coparceners, index) => {
                          if (index === rowIndex) {
                            return {
                              ...values,
                            };
                          }
                          return _coparceners;
                        })
                    );
                  } catch (e) {
                    return yupToFormErrors(e);
                  }
                }}
                enableReinitialize={true}>
                {({ handleSubmit, setFieldValue, values }) => (
                  <Grid
                    container
                    rowSpacing={1}
                    sx={{
                      width: '100%',
                      ml: 0,
                      '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
                      mt: 1,
                    }}
                    component="form"
                    noValidate
                    onSubmit={handleSubmit}>
                    <Grid item xs={12}>
                      <MFTextField name={`name`} label="Name *" placeholder="Enter Name" />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`pan`}
                        label="PAN"
                        placeholder="Enter Pan"
                        inputProps={{ style: { textTransform: 'uppercase' } }}
                        onChange={(e) => {
                          setFieldValue('pan', e.target.value.toUpperCase());
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <DatePicker
                        label={'Date of Birth *'}
                        inputLabelStyles={{
                          transform: 'unset',
                          fontSize: 14,
                          fontWeight: 500,
                          color: 'rgba(0,0,0,0.7)',
                        }}
                        placeholder={'DD/MM/YYYY'}
                        name={`dob`}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`mobile`}
                        label={`Mobile Number ${values?.karta ? '*' : ''}`}
                        placeholder="Enter Mobile Number"
                        onKeyDown={(e) => {
                          preventSpecialCharacters(e);
                        }}
                        startAdornment={
                          <CountryCodesDropDown
                            name={`countryNameAndCode`}
                            value={values.countryNameAndCode}
                          />
                        }
                        regexForFilterValue={nonDigitRegex}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <MFTextField
                        name={`email`}
                        label={`Email ID (Office ID Only) ${values?.karta ? '*' : ''}`}
                        placeholder="Enter Email ID"
                      />
                    </Grid>

                    <Grid item xs={12}>
                      <MFSelectField
                        name={`relation`}
                        label="Relationship *"
                        items={Relations.map((relation) => ({
                          key: relation,
                          value: relation,
                        }))}
                      />
                    </Grid>
                    {values.relation === 'Others' && (
                      <Grid item xs={12}>
                        <MFTextField
                          name={`relationShipOthers`}
                          label="Please Specify Relationship *"
                          placeholder={`Enter Relationship`}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <MFTextField
                        name={`designation`}
                        label="Designation *"
                        placeholder="Enter Designation"
                      />
                    </Grid>
                    <Grid xs={12} sm={12} lg={12} display="flex" sx={{ justifyContent: 'center' }}>
                      <Button
                        variant="contained"
                        sx={{
                          fontSize: 15,
                          minWidth: 180,
                          letterSpacing: 2,
                          fontWeight: 500,
                          alignSelf: 'center',
                          mt: 2,
                        }}
                        type="submit">
                        {coparcenersListing.name ? 'Save' : 'Add'}
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Formik>
            </Box>
          </Dialog>
          <ConfirmationDialog
            message={'Are you sure you want to delete Coparcener ?'}
            open={deletePopup}
            setOpen={() => setDeletePopup(false)}
            onSave={() => {
              setDeletePopup(false);
              const deletecoparceners = contributorValues.coparceners
                .filter((_item) => _item.isActive)
                .map((_coparceners, _ind) => {
                  if (rowIndex === _ind) {
                    return { ..._coparceners, isActive: false };
                  }
                  return _coparceners;
                });
              const deletedcoparcenerss = contributorValues.coparceners.filter(
                (_item) => !_item.isActive && _item.id
              );
              const active_Deletedcoparcenerss = deletecoparceners.filter(
                (_item) => _item.isActive || (!_item.isActive && _item.id)
              );
              setContributorValues({
                ...contributorValues,
                coparceners: [...active_Deletedcoparcenerss, ...deletedcoparcenerss],
              });
              setCoparceresListing(coparcenersListingObject);
              setRowIndex(Number);
            }}
            onCancel={() => {
              setCoparceresListing(coparcenersListingObject);
              setRowIndex(Number);
              setDeletePopup(false);
            }}
          />
        </Grid>
      </>
    );
  }

  const investorTypeMap = getInvestorTypeMasters(application?.createdAt || '');

  return (
    <Formik
      initialValues={contributorValues}
      validate={(values: Values) => {
        try {
          validateYupSchema(
            values,
            NonIndividualContributorValidationSchema(
              brokerList?.broker_list as Broker[],
              getOlderDate(application?.createdAt || '', application?.applicationCreatedAt || ''),
              ifPushToXalt(application?.pushDataTo || ''),
              toggler
            ),
            true,
            values
          );
        } catch (e) {
          return yupToFormErrors(e);
        }
      }}
      onSubmit={handleSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, setValues }) => (
        <>
          <Grid
            container
            rowSpacing={1}
            //columnSpacing={5}
            sx={{
              width: '100%',
              ml: 0,
              '.MuiGrid-item': { px: { xs: 0, sm: '30px' } },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            {values.applicants.map((applicant, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.name`}
                    label="Name of Entity *"
                    placeholder="Enter Name of Entity"
                    disabled={applicant.dataFetchedFromKRA || false || !!application?.isTopup}
                  />
                </Grid>
                {console.log(values, 'checkvalues')}
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label={'Date of Registration/Incorporation *'}
                    inputLabelStyles={{
                      transform: 'unset',
                      fontSize: 14,
                      fontWeight: 500,
                      color: 'rgba(0,0,0,0.7)',
                    }}
                    placeholder={'DD/MM/YYYY'}
                    name={`applicants.${index}.dateOfBirth`}
                    disabled={applicant.dataFetchedFromKRA || false || !!application?.isTopup}
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.cityOfIncorporation`}
                    label="Place of Registration/Incorporation *"
                    placeholder="Enter Place of Registration/Incorporation"
                    disabled={!!application?.isTopup}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ '.MuiFormControl-root': { marginBottom: '2px', marginTop: '16px' } }}>
                  <UseRadioGroup
                    formLabel={'Ckyc selection options *'}
                    name={`applicants.${index}.ckyc_selection_options`}
                    items={Object.keys(CKYC_SELECTION_OPTIONS_OBJECT).map((option) => ({
                      label: CKYC_SELECTION_OPTIONS_OBJECT[option],
                      value: option,
                    }))}
                  />
                  {!isCkycMandatory(values.applicants[index].ckyc_selection_options || '') && (
                    <Notes displayContent={ckycDeclaration} />
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.ckycNo`}
                    label={`CKYC No./CKYC Acknowledge No./KIN No' ${
                      isCkycMandatory(values.applicants[index].ckyc_selection_options || '')
                        ? ' *'
                        : ''
                    }`}
                    placeholder="Enter CKYC No./CKYC Acknowledge No./KIN No"
                    disabled={!!application?.isTopup}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.investorType`}
                    label="Investor Type *"
                    items={Object.keys(investorTypeMap).map((investor) => ({
                      key: investorTypeMap[investor],
                      value: investor,
                    }))}
                    disabled={!!application?.isTopup}
                  />
                </Grid>
                {isOtherTypeOfInvestor(values.applicants[index].investorType || '') && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.otherInvestorType`}
                      label="Please Specify Investor Type *"
                      placeholder="Enter Investor Type"
                    />
                  </Grid>
                )}
                {ifPushToXalt(application?.pushDataTo || '') &&
                  investorTypeMasters[values?.applicants[index]?.investorType || ''] ===
                    investorTypeMasters.boi_or_aop && (
                    <Grid item xs={12} sm={6}>
                      <MFSelectField
                        name={`applicants.${index}.boiOrAop`}
                        label="AOP or BOI *"
                        items={Object.keys(AOI_BOI_MASTER).map((investor) => ({
                          key: AOI_BOI_MASTER[investor],
                          value: investor,
                        }))}
                      />
                    </Grid>
                  )}
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.panNo`}
                    label="PAN *"
                    placeholder="Enter PAN"
                    disabled={true}
                  />
                </Grid>
                {applicant.kraMobileNumber && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.kraMobileNumber`}
                      label={`KRA Mobile Number`}
                      placeholder="Enter KRA Mobile Number"
                      disabled={true}
                      regexForFilterValue={nonDigitRegex}
                    />
                  </Grid>
                )}
                {applicant.kraEmailId && (
                  <Grid item xs={12} sm={6}>
                    <MFTextField
                      name={`applicants.${index}.kraEmailId`}
                      label={`KRA Email Id`}
                      placeholder="Enter KRA Email Id"
                      disabled={true}
                    />
                  </Grid>
                )}
                <SubHeading
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  Other Details
                </SubHeading>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.grossAnnualIncome`}
                    label="Gross Annual Income *"
                    items={getGrossAnnualMasters(application?.createdAt || '').map(
                      (grossIncome) => ({
                        key: grossIncome,
                        value: grossIncome,
                      })
                    )}
                    disabled={!!application?.isTopup}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFTextField
                    name={`applicants.${index}.netWorth`}
                    label="Net Worth *"
                    placeholder="Enter Net Worth"
                    disabled={!!application?.isTopup}
                  />
                  {values.applicants[index].netWorth &&
                    !isNaN(Number(values.applicants[index].netWorth)) && (
                      <Typography sx={{ fontSize: 13 }}>
                        {currencyConversion(values.applicants[index].netWorth)}
                      </Typography>
                    )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.politicallyExposedPersonStatus`}
                    label="Politically Exposed Person (PEP) Status"
                    items={PEPsMasters.map((pep) => ({ key: pep, value: pep }))}
                    disabled={!!application?.isTopup}
                  />
                  {isValidPEP(values.applicants[index].politicallyExposedPersonStatus || '') && (
                    <Notes displayContent={'PEP document to be uploaded'} />
                  )}
                </Grid>
                <DematDetails
                  index={index}
                  values={values}
                  brokers={brokerList?.broker_list as Broker[]}
                  createdAt={application?.createdAt || ''}
                  dpBroker={dpbrokerList}
                />
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ '.MuiFormControl-root': { marginBottom: '2px', marginTop: '16px' } }}>
                  <UseRadioGroup
                    formLabel="AMC Call Verified? *"
                    name={`applicants.${index}.amcCallVerified`}
                    items={Object.keys(YES_NO_MASTER).map((option) => ({
                      label: YES_NO_MASTER[option],
                      value: option,
                    }))}
                  />
                  {isAmcCallVerified(values.applicants[index].amcCallVerified || '') && (
                    <Notes displayContent={'AMC call waiver document to be uploaded'} />
                  )}
                </Grid>
                <Grid item xs={12} sm={6}>
                  <MFSelectField
                    name={`applicants.${index}.sourceOfFunds`}
                    label="Source Of Funds"
                    items={Object.keys(SOURCE_OF_FUNDS_MASTER)?.map((item: string) => ({
                      key: SOURCE_OF_FUNDS_MASTER[item],
                      value: item,
                    }))}
                    disabled={!!application?.isTopup}
                  />
                  {values.applicants[index]?.sourceOfFunds && (
                    <Notes displayContent={'Relevant source of fund document to be uploaded'} />
                  )}
                </Grid>
                {values.applicants[index].sourceOfFunds &&
                  isOtherSourceOfFund(values.applicants[index].sourceOfFunds || '') && (
                    <Grid item xs={12} sm={6}>
                      <MFTextField
                        name={`applicants.${index}.otherSourceOfFunds`}
                        label="Please Specify Other Source Of Funds *"
                        placeholder="Enter other source of funds"
                        disabled={!!application?.isTopup}
                      />
                    </Grid>
                  )}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ '.MuiFormControl-root': { marginBottom: '2px', marginTop: '16px' } }}>
                  <UseRadioGroup
                    formLabel="KYC Compliant *"
                    name={`applicants.${index}.dataFetchedFromKRA`}
                    items={Object.keys(YES_NO_BOOLEAN_MASTER).map((option) => ({
                      label: YES_NO_BOOLEAN_MASTER[option],
                      value: option,
                    }))}
                    disabled={true}
                    value={values.applicants[index].dataFetchedFromKRA?.toString()}
                  />
                </Grid>
              </React.Fragment>
            ))}
            {isHufType(values.applicants) &&
              !checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) && (
                <>
                  <SubHeading
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}>
                    List of Coparceners
                  </SubHeading>
                  <CoparceresDetails coparcenersValues={values} />
                </>
              )}
            <ProceedSaveLater
              saveLater={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save for later',
                });
              }}
              saveAndProceed={() => {
                setValues({
                  ...values,
                  applicants: values.applicants.map((applicant) => ({
                    ...applicant,
                  })),
                  saveType: 'save and proceed',
                });
              }}
              loader={loading}
              clickedButton={values.saveType}
            />
          </Grid>
        </>
      )}
    </Formik>
  );
}
